export default __webpack_public_path__ + "static/media/expensive.a9f42222.svg";